

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { pageRouteUrls } from "../helper/pageRouteUrls";
import { useCurrUserUtility } from "../contexts/useCurrUserUtility";
import { NavigationLink } from "../models/NavigationLink";
import { AccountInfoModel, UserTypeEnum } from "../generated/api";


export const navigationLinks0:NavigationLink[] = [
    { label: "Home", url: pageRouteUrls.Home() },
    { label: "Dashboard", url: pageRouteUrls.Dashboard(),isAuth:true }, 
    { label: "Tutors", url: pageRouteUrls.Search()+'/?types=2', isAuth:true, userTypes:[UserTypeEnum.Tutor],
      subMenu: [{label: "Following", url: pageRouteUrls.InstructorFollowList() } ] 
    },     
    {
        label: "Courses",
        url: pageRouteUrls.Search()+'/?types=3',
        subMenu: [ 
            { label: "My Courses", url: pageRouteUrls.CourseMy() ,isAuth:true },
            { label: "Courses Details", url: pageRouteUrls.CourseView('7F67B061-3E60-45E8-B7EC-F8ADE86ADC55') },
            { label: "Courses Content", url: pageRouteUrls.CourseContent('7F67B061-3E60-45E8-B7EC-F8ADE86ADC55') },
            // { label: "Lecture Access Manager", url: pageRouteUrls.AccessManager() },
            { label: "Lecture Live Session", url: pageRouteUrls.LectureLiveSession('7F67B061-3E60-45E8-B7EC-F8ADE86ADC55') }, 
        ],
        btnMenu: [
          { label: "Add Course", url: pageRouteUrls.CourseAdd() ,isAuth:true },
        ]
    },
    {
      label:'Admin Panel',
      isAuth:true ,
      url: pageRouteUrls.InstructorFollowList(),
      subMenu: [
          { label: "Payments", url: pageRouteUrls.Payments() }          
      ]
    },
     
];

// ─────────────────────────────────────────────
//  navigationLinks — role-based menu structure
//  userTypes: undefined  → visible to everyone (guests included)
//  userTypes: [...]      → visible only to listed roles
//  isAuth: true          → requires login
// ─────────────────────────────────────────────
export const navigationLinks: NavigationLink[] = [

   
  // ── Everyone (guest + authenticated) ───────
    { label: "Dashboard", url: pageRouteUrls.Dashboard(),isAuth:true },
  // ── Student (0) ────────────────────────────
  {
    label: "Courses",
    url: pageRouteUrls.CourseMy(),
    isAuth: true,
    userTypes: [UserTypeEnum.Student],
    subMenu: [
      { label: "My Courses & Lectures",    url: pageRouteUrls.CourseMy(),             isAuth: true },
      
      { label: "Homework",    url: pageRouteUrls.MyHomework(),             isAuth: true },
      { label: "Exams",    url: pageRouteUrls.MyExams(),             isAuth: true },
      { label: "Certificates",    url: pageRouteUrls.MyCertificates(),             isAuth: true },

      { label: "Following",      url: pageRouteUrls.InstructorFollowList(), isAuth: true },
      { label: "Favorites",      url: pageRouteUrls.FavoriteLists(), isAuth: true },
    ],
  },

  // ── Homework & Exams (Student + Parent) ────
  // {
  //   label: "Homework",
  //   url: pageRouteUrls.MyHomework(),
  //   isAuth: true,
  //   userTypes: [UserTypeEnum.Student, UserTypeEnum.Parent],
  // },
  // {
  //   label: "Exams",
  //   url: pageRouteUrls.MyExams(),
  //   isAuth: true,
  //   userTypes: [UserTypeEnum.Student, UserTypeEnum.Parent],
  // },
  // {
  //   label: "Certificates",
  //   url: pageRouteUrls.MyCertificates(),
  //   isAuth: true,
  //   userTypes: [UserTypeEnum.Student],
  // },

  // ── Tutor (1) ────────────────────────────── 
  {
    label: "Courses",
    url: pageRouteUrls.CourseMy(),
    isAuth: true,
    userTypes: [UserTypeEnum.Tutor],
    subMenu: [
      { label: "My Courses & Lectures",    url: pageRouteUrls.CourseMy(),             isAuth: true },
      { label: "Question Bank",  url: pageRouteUrls.QuestionBank(), isAuth: true },
      { label: "Favorites",      url: pageRouteUrls.FavoriteLists(), isAuth: true },
      { label: "Following",      url: pageRouteUrls.InstructorFollowList(), isAuth: true },
    ],
    btnMenu: [
      { label: "Add Course", url: pageRouteUrls.CourseAdd(), isAuth: true },
    ],
  },
  {
    label: "Students",
    url: pageRouteUrls.MyStudents(),
    isAuth: true,
    userTypes: [UserTypeEnum.Tutor],
    subMenu: [
      { label: "My Students",   url: pageRouteUrls.MyStudents(),                      isAuth: true },
      { label: "Find Students", url: pageRouteUrls.Search() + "/?types=student",      isAuth: true },
      { label: "Invoices",      url: pageRouteUrls.StudentInvoices(),                 isAuth: true },
    ],
  },

  // ── Parent (2) ─────────────────────────────
  {
    label: "My Children", 
    url: pageRouteUrls.MyChildrenPage(),
    isAuth: true,
    userTypes: [UserTypeEnum.Parent],
  },
  {
    label: "Courses",
    url: pageRouteUrls.CourseMy() ,
    isAuth: true,
    userTypes: [UserTypeEnum.Parent], 
    subMenu: [
      { label: "My Courses & Lectures",    url: pageRouteUrls.CourseMy(),             isAuth: true },
      
      { label: "Homework",    url: pageRouteUrls.MyHomework(),             isAuth: true },
      { label: "Exams",    url: pageRouteUrls.MyExams(),             isAuth: true },
      { label: "Certificates",    url: pageRouteUrls.ChildrenCertificates(),             isAuth: true },

      { label: "Following",      url: pageRouteUrls.InstructorFollowList(), isAuth: true },
      { label: "Favorites",      url: pageRouteUrls.FavoriteLists(), isAuth: true },
    ],
  },
  {
    label: "Reports",
    url: pageRouteUrls.ParentReports(),
    isAuth: true,
    userTypes: [UserTypeEnum.Parent]
  }, 
  // ── Academy (3) ────────────────────────────
  {
    label: "Tutors",
    url: pageRouteUrls.AcademyTutors(),
    isAuth: true,
    userTypes: [UserTypeEnum.Academy],
    subMenu: [
      { label: "Manage Tutors", url: pageRouteUrls.AcademyTutors(),                     isAuth: true },
      { label: "Following",    url: pageRouteUrls.InstructorFollowList(),               isAuth: true },
    ],
  },
  {
    label: "Courses",
    url: pageRouteUrls.CourseMy(),
    isAuth: true,
    userTypes: [UserTypeEnum.Academy],
    subMenu: [
      { label: "My Courses & Lectures",    url: pageRouteUrls.CourseMy(),             isAuth: true },
      { label: "Question Bank",  url: pageRouteUrls.QuestionBank(), isAuth: true },
      { label: "Favorites",      url: pageRouteUrls.FavoriteLists(), isAuth: true },
      { label: "Following",      url: pageRouteUrls.InstructorFollowList(), isAuth: true },
    ],
    btnMenu: [
      { label: "Add Course", url: pageRouteUrls.CourseAdd(), isAuth: true },
    ],
  },   
  {
    label: "Students",
    url: pageRouteUrls.MyStudents(),
    isAuth: true,
    userTypes: [UserTypeEnum.Academy],
    subMenu: [
      { label: "My Students",   url: pageRouteUrls.MyStudents(),                      isAuth: true },
      { label: "Find Students", url: pageRouteUrls.Search() + "/?types=student",      isAuth: true },
      { label: "Invoices",      url: pageRouteUrls.StudentInvoices(),                 isAuth: true },
    ],
  },
  {
    label: "Reports",
    url: pageRouteUrls.AcademyReports(),
    isAuth: true,
    userTypes: [UserTypeEnum.Academy],
    subMenu: [
      { label: "Academy Reports",   url: pageRouteUrls.AcademyReports(), isAuth: true },
      { label: "Payments Overview", url: pageRouteUrls.Payments(),       isAuth: true },
    ],
  },
  
  // ── Admin (4) ────────────────────────────────
  {
    label: "Admin",
    url: pageRouteUrls.InstructorVerificationList(),
    isAuth: true,
    userTypes: [UserTypeEnum.Admin],
    subMenu: [
      { label: "Verification Management", url: pageRouteUrls.InstructorVerificationList(), isAuth: true },
      { label: "Payments",                url: pageRouteUrls.Payments(),                   isAuth: true },
      { label: "Users",                   url: pageRouteUrls.AdminUsersList(),              isAuth: true },
      { label: "Calls",                   url: pageRouteUrls.AdminCalls(),                  isAuth: true },
    ],
  }, 
  {
    label: "Marketing",
    url: pageRouteUrls.AdminMarketingEmails(),
    isAuth: true,
    userTypes: [UserTypeEnum.Admin],
    subMenu: [
      { label: "Outreach Emails",      url: pageRouteUrls.AdminMarketingEmails(), isAuth: true },
      { label: "WhatsApp Campaigns",   url: pageRouteUrls.AdminMarketingWhatsApp(), isAuth: true },
      { label: "Promo Codes",             url: pageRouteUrls.AdminPromoCodes(),             isAuth: true },
    ],
  },
];

// ─────────────────────────────────────────────
//  Helper — exported so Header.tsx can reuse it
//  if needed (e.g. for mobile menu)
// ─────────────────────────────────────────────
export const isLinkVisible = (
  item: NavigationLink,
  authenticated: boolean,
  userType: UserTypeEnum | undefined
): boolean => {
  if (item.guestOnly === true && authenticated) return false;
  if (item.isAuth === true && !authenticated) return false;
  if (item.userTypes && item.userTypes.length > 0) {
    if (userType === undefined) return false;
    if (!item.userTypes.includes(userType)) return false;
  }
  return true;
};

// ─────────────────────────────────────────────
//  Navigationbar
//
//  Renders only <li> items — NO wrapping div or ul.
//  Usage in Header.tsx:
//
//    <ul className="nav-menu">
//      <Navigationbar />
//    </ul>
// ─────────────────────────────────────────────
const Navigationbar = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { isAuth, getCurrUser } = useCurrUserUtility();
  // Menu labels are defined in English above; translate at render time
  // via the "nav" resource section (falls back to the English label).
  const tl = (label: string) => t(`nav.${label}`, { defaultValue: label });
  const [usr, setUsr] = useState<AccountInfoModel | undefined>(getCurrUser());

  useEffect(() => {
    setUsr(getCurrUser());
  }, [isAuth()]);

  const authenticated = isAuth();
  const userType = usr?.userType ;

  const isNavLinkActive = (url: string): boolean =>
    location.pathname.startsWith(url);

  const visibleLinks = navigationLinks.filter((item) =>
    isLinkVisible(item, authenticated, userType)
  ); 

  return (
    <>
      {visibleLinks.map((item, index) => {
        const visibleSub = item.subMenu?.filter((sub) =>
          isLinkVisible(sub, authenticated, userType)
        );
        const visibleBtn = item.btnMenu?.filter((btn) =>
          isLinkVisible(btn, authenticated, userType)
        );

        return (
          <li key={index} className={isNavLinkActive(item.url) ? "active" : ""}>
            <a href={item.url}>{tl(item.label)}</a>

            {/* Dropdown — sub-links + CTA buttons in one <ul> */}
            {((visibleSub && visibleSub.length > 0) || (visibleBtn && visibleBtn.length > 0)) && (
              <ul className="sub-menu">
                {/* Regular sub-links */}
                {visibleSub?.map((subItem, subIndex) => (
                  <li
                    key={`sub-${subIndex}`}
                    className={isNavLinkActive(subItem.url) ? "active" : ""}
                  >
                    <a href={subItem.url}>{tl(subItem.label)}</a>
                  </li>
                ))}

                {/* Separator + CTA buttons at the bottom */}
                {visibleBtn && visibleBtn.length > 0 && (
                  <>
                    {visibleSub && visibleSub.length > 0 && (
                      <li style={{ padding: "4px 20px 0", listStyle: "none" }}>
                        <hr style={{ margin: "4px 0", borderColor: "rgba(0,0,0,0.1)" }} />
                      </li>
                    )}
                    {visibleBtn.map((btnItem, btnIndex) => (
                      <li key={`btn-${btnIndex}`} style={{ padding: "4px 12px 8px" }}>
                        <Link
                          to={btnItem.url}
                          style={{
                            display: "block",
                            padding: "7px 14px",
                            borderRadius: "6px",
                            background: "#309255",
                            color: "#fff",
                            fontWeight: 600,
                            fontSize: "13px",
                            textAlign: "center",
                            textDecoration: "none",
                            transition: "background 0.2s",
                          }}
                          onMouseEnter={e => (e.currentTarget.style.background = "#1e6040")}
                          onMouseLeave={e => (e.currentTarget.style.background = "#309255")}
                        >
                          + {tl(btnItem.label)}
                        </Link>
                      </li>
                    ))}
                  </>
                )}
              </ul>
            )}
          </li>
        );
      })}
    </>
  );
};

export default Navigationbar;